import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { Observable, of } from "rxjs";
import { Subject } from "rxjs";

import { DataService } from "./../../data.service";
import { AppConfig } from "./../../config";

@Component({
  selector: "app-recordtypeview",
  templateUrl: "./recordtypeview.component.html",
  styleUrls: ["./recordtypeview.component.scss"],
})
export class RecordTypeViewComponent implements OnInit {
  recordType: any;
  isLoading = false;
  isError = false;
  errorMessage = "";
  recordTypeId = "";
  recordTypeName = "";
  metaobjectId = "";
  metaobjectName = "";
  dataSource = "";

  detailForm = this.fb.group({
    metaobjectid: "",
    id: "",
    displayname: "",
    name: "",
    description: "",
    process: "",
    active: new FormControl({ value: true, disabled: true }),
  });
  fields: any;

  displayedColumns: string[] = ["action", "fieldname", "modifieddate"];
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private appConfig: AppConfig,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      this.recordTypeId = this.route.snapshot.params.id;
      this.recordTypeName = this.route.snapshot.params.name;
      this.metaobjectId = this.route.snapshot.params.metaobjectid;
      this.metaobjectName = this.route.snapshot.params.metaobjectname;
    });

    this.getRecordTypeById();
    this.getMetaFieldsForSelection();
  }

  metaobjectDetail() {
    this.router.navigateByUrl(
      "home/metaobjectdetail/" + this.metaobjectId + "/" + this.metaobjectName
    );
  }

  editRecordType() {
    this.router.navigateByUrl(
      "/home/recordtype/edit/" +
        this.recordTypeId +
        "/" +
        this.recordTypeName +
        "/" +
        this.metaobjectId +
        "/" +
        this.metaobjectName
    );
  }
  // editApp(element: any) {
  //   const queryParams = {
  //     attributes: JSON.stringify(element.attributes), // Serialize the attributes object to JSON string
  //   };
  //   console.log("queryParams", queryParams);
  //   this.router.navigateByUrl(
  //     "/home/recordtype/picklist/available/" +
  //       element.fieldname +
  //       "/" +
  //       this.recordTypeId +
  //       "/" +
  //       this.recordTypeName +
  //       "/" +
  //       this.metaobjectId +
  //       "/" +
  //       this.metaobjectName,
  //     { queryParams }
  //   );
  // }
  editApp(element: any) {
    const queryParams = {
      attributes: JSON.stringify(element.attributes), // Serialize the attributes object to JSON string
    };

    console.log("queryParams", queryParams);

    this.router.navigate(
      [
        "/home/recordtype/picklist/available",
        element.fieldname,
        this.recordTypeId,
        this.recordTypeName,
        this.metaobjectId,
        this.metaobjectName,
      ],
      { queryParams }
    );
  }

  getRecordTypeById() {
    let postOption = {
      organizationid: localStorage.getItem("crm_orgid"),
      userid: localStorage.getItem("crm_userid"),
      username: localStorage.getItem("crm_username"),
      // domain: localStorage.getItem("domain"),
      // subdomain: localStorage.getItem("subdomain"),
      domain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.domain`
      ),
      subdomain: localStorage.getItem(
        `${localStorage.getItem("crm_orgid")}.subdomain`
      ),
      data: {
        recordtype: {
          id: this.recordTypeId,
        },
      },
    };

    this.isLoading = true;
    this.dataService.getRecordTypeById(postOption).subscribe(
      (res) => {
        //alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          this.recordType = res.data.recordtype;
          if (this.recordType != null) {
            this.metaobjectId = this.recordType.metaobjectid;

            this.detailForm.controls["metaobjectid"].setValue(
              this.recordType.metaobjectid
            );
            this.detailForm.controls["id"].setValue(this.recordType.id);
            this.detailForm.controls["displayname"].setValue(
              this.recordType.displayname
            );
            this.detailForm.controls["name"].setValue(this.recordType.name);
            this.detailForm.controls["description"].setValue(
              this.recordType.description
            );
            this.detailForm.controls["process"].setValue(
              this.recordType.processname
            );
            this.detailForm.controls["active"].setValue(this.recordType.active);
          }
          this.isLoading = false;
        } else {
          console.log("no data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  getMetaFieldsForSelection() {
    return new Promise((resolve, reject) => {
      console.log("getMetaFieldsForSelection");

      var userDetail = JSON.parse(localStorage.getItem("crm_userdetails"));

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        userid: localStorage.getItem("crm_userid"),
        username: localStorage.getItem("crm_username"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.domain`
        ),
        subdomain: localStorage.getItem(
          `${localStorage.getItem("crm_orgid")}.subdomain`
        ),
        profileid: userDetail.profileid,
        data: {
          metafield: {
            metaobjectid: this.metaobjectId,
            metaobjectname: this.metaobjectName,
          },
        },
      };

      console.log("postOption", postOption);

      this.isLoading = true;
      this.dataService.getMetaFieldsForSelection(postOption).subscribe(
        (res) => {
          console.log(res);
          if (res !== null && res.success == 1) {
            this.fields = res.data.metafields;

            // //add default --None-- into field list
            // this.fieldList.push({
            //   value: "--None--",
            //   label: "--None--",
            //   fieldtype: "text",
            //   standard: true,
            //   options: [],
            //   id: "",
            // });

            if (this.fields != null) {
              this.dataSource = this.fields
                .filter(
                  (field) =>
                    field.fieldtype === "picklist" &&
                    field.attributes.picklisttype === "static"
                )
                .map((item) => ({
                  id: item.id,
                  fieldname: item.fieldname,
                  attributes: item.attributes,

                  modifieddate: item.modifieddate,

                  // type: item.actiontype,
                  // content: item.content,
                  // metalayoutid: item.metalayoutid,
                }));
            }

            // this.sortFieldList.push({
            //   value: "--None--",
            //   label: "--None--",
            //   fieldtype: "text",
            //   standard: true,
            //   options: [],
            //   id: "",
            // });

            // //create fieldlist from fields as readable form by selection control
            // for (let i = 0; i < this.fields.length; i++) {
            //   var field = this.fields[i];

            //   //skip id type fields if there
            //   if (field.fieldtype.toLowerCase() == "id") continue;

            //   //skip fields with visibility false
            //   if (field.visible == false) continue;

            //   //skip fields deleted, ownertype etc.,
            //   if (
            //     field.fieldname.toLowerCase() == "deleted" ||
            //     field.fieldname.toLowerCase() == "ownertype" ||
            //     field.fieldname.toLowerCase() == "migrated" ||
            //     field.fieldname.toLowerCase() == "organizationid" ||
            //     field.fieldname.toLowerCase() == "search" ||
            //     field.fieldname.toLowerCase() == "date_range"
            //   )
            //     continue;

            //   //skip converted field if object is lead
            //   if (
            //     this.metaobjectName.toLowerCase().trim() == "lead" &&
            //     field.fieldname.toLowerCase() == "converted"
            //   )
            //     continue;

            //   //convert to titecase
            //   var strLabel = field.labelname;

            //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
            //   this.fieldList.push({
            //     value: field.fieldname,
            //     label: strLabel,
            //     fieldtype: field.fieldtype,
            //     standard: field.standard,
            //     options: field.options,
            //     id: field.id,
            //   });
            // }

            // for (let i = 0; i < this.fields.length; i++) {
            //   var field = this.fields[i];
            //   console.log(field.fieldtype);

            //   //skip id type fields if there
            //   if (field.fieldtype.toLowerCase() == "id") continue;

            //   //skip fields with visibility false
            //   if (field.visible == false) continue;

            //   //skip fields deleted, ownertype etc.,
            //   if (
            //     field.fieldname.toLowerCase() == "deleted" ||
            //     field.fieldname.toLowerCase() == "ownertype" ||
            //     field.fieldname.toLowerCase() == "migrated" ||
            //     field.fieldname.toLowerCase() == "organizationid" ||
            //     field.fieldname.toLowerCase() == "search" ||
            //     field.fieldname.toLowerCase() == "date_range"
            //   )
            //     continue;

            //   //skip converted field if object is lead
            //   if (
            //     this.metaobjectName.toLowerCase().trim() == "lead" &&
            //     field.fieldname.toLowerCase() == "converted"
            //   )
            //     continue;

            //   if (
            //     field.fieldtype.toLowerCase() !== "text" &&
            //     field.fieldtype.toLowerCase() !== "number" &&
            //     field.fieldtype.toLowerCase() !== "date" &&
            //     field.fieldtype.toLowerCase() !== "datetime"
            //   )
            //     continue;

            //   //convert to titecase
            //   var strLabel = field.labelname;

            //   strLabel = strLabel[0].toUpperCase() + strLabel.slice(1);
            //   this.sortFieldList.push({
            //     value: field.fieldname,
            //     label: strLabel,
            //     fieldtype: field.fieldtype,
            //     standard: field.standard,
            //     options: field.options,
            //     id: field.id,
            //   });
            // }

            this.isLoading = false;
            resolve(null);
          } else {
            console.log("No fields data!");
            this.isLoading = false;
            resolve(null);
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
